const translateValue = (value, t, tm) => {
  if (Array.isArray(value)) {
    return value.map((item) => translateValue(item, t, tm))
  }

  if (value && typeof value === 'object' && value.valueKey) {
    const translated = tm(value.valueKey)

    if (Array.isArray(translated)) {
      return translated.map((item) => translateValue(item, t, tm))
    }

    if (translated && typeof translated === 'object') {
      return translated
    }

    return translated === value.valueKey ? t(value.valueKey) : translated
  }

  return value
}

export const translateSpecTabs = (specTabs, t, tm) => {
  return specTabs.map((tab) => {
    const tabLabelKey = tab.labelKey || tab.label
    const tabRows = tab.rows || tab.tableData

    if (!tabLabelKey) {
      throw new Error(`Missing spec tab labelKey: ${tab.label || 'unknown tab'}`)
    }

    if (!Array.isArray(tabRows)) {
      throw new Error(`Missing spec tab rows for ${tabLabelKey}`)
    }

    return {
      label: t(tabLabelKey),
      rows: tabRows.map((row) => {
        const rowLabelKey = row.labelKey || row.title

        if (!rowLabelKey) {
          throw new Error(`Missing spec row labelKey in ${tabLabelKey}`)
        }

        return {
          label: t(rowLabelKey),
          value: translateValue(row.value ?? row.contentList, t, tm)
        }
      })
    }
  })
}
